import axios from '../javascript/custom-axios'
const RESOURCE_NAME = 'categories'

export default { 
  uploadFile(body){
    return axios.post(`/upload`, body)
  },
}